'use strict';

/**
 * @ngdoc function
 * @name myConsultApp.controller:editProPet
 * @description
 * # editProPet
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'editProPet',
    function (
      $scope,
      $rootScope,
      $route,
      $routeParams,
      $location,
      $timeout,
      crumble,
      PetsService,
      IdentityService,
      ProvidersService,
      $filter,
      utilities,
      BrowserService,
    ) {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      $scope.crumble = crumble;

      crumble.update();
      ProvidersService.setPetownerZipcode(null);
      $scope.currentPetId = $routeParams.petId;
      $scope.ownerId = $routeParams.ownerId;
      $scope.currentPet = { pet: {} };
      $scope.sheltarModalTitle = 'Choose Shelter';
      $scope.veterinarianModalTitle = 'Choose Veterinarian';
      $scope.isMale = { value: null };
      $scope.breedList = null;
      $scope.todaysDate = new Date();
      $scope.petDobInvalid = false;
      $scope.formcheckDirty = false;
      $scope.selectedOwner = null;
      $scope.lastBreedValue = null;
      $scope.currentBreedTitle = null;
      $scope.currentPetBreedId = null;
      $scope.invalidFile = null;
      $scope.deleteConfirmation = false;
      $scope.statuses = null;
      $scope.thresholdMet = false;
      $scope.currentStatus = { status: null };
      $scope.showDenialReason = false;
      $scope.denyReason = { denial_reason: null, notes: null };
      $scope.denialError = { denialReason: false, notes: false };

      $scope.denyReasonCopy = angular.copy($scope.denyReason);
      $scope.denialErrorCopy = angular.copy($scope.denialError);
      $scope.appDenialReasons = null;
      $scope.tempInfo = {};
      $scope.showDenialReasonOther = false;

      window.scrollTo(0, 0);
      var providerData = {
        petProvider: {
          organization: $scope.selectedSheltar,
          relation_type: 'shelter',
        },
      };

      $scope.selectBreed = function ($item) {
        $scope.error.status = false;
        $scope.error.highlightedFields.breed = false;
        if ($item !== undefined) {
          $scope.currentPetBreedId = $item.originalObject.id;
          $scope.lastBreedValue = $item;
          $scope.currentPet.pet.breed = $item.title;
          $scope.currentBreedTitle = $item.originalObject.id;
        } else {
          $scope.lastBreedValue = null;
          $scope.currentBreedTitle = '';
          $scope.currentPetBreedId = null;
        }
      };

      $scope.checkBreedValue = function () {
        $scope.error.status = false;
        $scope.error.highlightedFields.breed = false;
        if ($scope.lastBreedValue == null) {
          $scope.error.status = true;
          $scope.error.highlightedFields.breed = ['Invalid breed'];
        }
      };

      $scope.setSpecies = function () {
        var auxBreedList = [];
        angular.forEach($rootScope.breedList, function (value, key) {
          if (value.species == $scope.currentPet.pet.species) {
            auxBreedList.push(value);
          }
        });
        $scope.breedList = auxBreedList;
        $scope.currentPet.pet.breed = null;
        $scope.currentBreedTitle = '';
        $scope.lastBreedValue = null;
        $scope.currentPetBreedId = null;
        $('#petBreedList_value').val('');
      };

      $scope.updateGender = function (gender) {
        if ($scope.currentPet.pet.petprofile != undefined) {
          $scope.isMale.value = gender;
        }
      };

      $scope.selectownerIdetification = function (param) {
        if ($scope.currentPet.pet.petprofile != undefined) {
          if ($scope.currentPet.pet.petprofile[param.value] == true) return true;
        }
      };

      $scope.currentPreviousMedical = function (param) {
        if ($scope.currentPet.pet.petprofile != undefined) {
          if ($scope.currentPet.pet.petprofile.medical_conditions.includes(param.value))
            return true;
        }
      };

      $scope.relatedMedical = function (param) {
        if ($scope.currentPet.pet.petprofile != undefined) {
          if ($scope.currentPet.pet.petprofile.family_medical_conditions.includes(param.value))
            return true;
        }
      };

      $scope.genders = [
        { name: 'Male', value: true },
        { name: 'Female', value: false },
      ];
      $scope.petactives = [
        { name: 'Active', value: true },
        { name: 'Archived', value: false },
      ];
      $scope.species = [
        { name: 'Dog', value: 1 },
        { name: 'Cat', value: 2 },
      ];
      $scope.ownerIdetifications = [
        { name: 'ID Collar / Harness', value: 'id_has_collar' },
        { name: 'ID Tag', value: 'id_has_tag' },
        { name: 'Microchip', value: 'id_has_id_chip' },
      ];

      var medical_conditions = [
        { name: 'Eyes', value: 'eyes' },
        { name: 'Ears', value: 'ears' },
        { name: 'Teeth and Mouth', value: 'teeth_and_mouth' },
        { name: 'Skin and Coat', value: 'skin_and_coat' },
        { name: 'Heart', value: 'heart' },
        { name: 'Breathing', value: 'breathing' },
        { name: 'Bones and Joints', value: 'bones_and_joints' },
        { name: 'Alertness and Balance', value: 'alertness_and_nerves' },
        { name: 'Urinary Tract', value: 'bathroom_habits_urine' },
        { name: 'Cancer', value: 'cancer' },
        { name: 'Digestion', value: 'digestion' },
      ];

      $scope.medical_conditions = angular.copy(medical_conditions);

      $scope.family_medical_conditions = angular.copy(medical_conditions);

      $scope.neutered = [
        { name: 'Neutered less than 4 months old', value: 'LTS' },
        { name: 'Neutered between 4-12 months', value: 'STT' },
        { name: 'Neutered when older than 1 year', value: 'OOY' },
        { name: 'Neutered but unsure at what age', value: 'UNS' },
        { name: 'Not neutered, I plan to breed him', value: 'YE' },
        { name: 'Not neutered, I don’t plan to breed him', value: 'NO' },
        { name: 'Not neutered, not decided about breeding him', value: 'NS' },
        { name: 'Unsure if neutered', value: 'UN' },
      ];
      $scope.spayed = [
        { name: 'Spayed less than 4 months old', value: 'LTS' },
        { name: 'Spayed between 4-12 months', value: 'STT' },
        { name: 'Spayed when older than 1 year', value: 'OOY' },
        { name: 'Spayed but unsure at what age', value: 'UNS' },
        { name: 'Not spayed, I plan to breed her', value: 'YE' },
        { name: 'Not spayed, I don’t plan to breed her', value: 'NO' },
        { name: 'Not spayed, not decided about breeding her', value: 'NS' },
        { name: 'Unsure if spayed', value: 'UN' },
      ];

      $scope.error = {
        status: false,
        details: '',
        highlightedFields: { breed: [] },
      };

      $scope.submit = {
        success: false,
      };

      $scope.reloadRoute = function () {
        $scope.submit.success = false;
        $route.reload();
      };

      $scope.tab = {
        id: 'editpet',
        current: '',
      };

      $scope.tabChanges = function (param) {
        if (param == 'ok') {
          $scope.formcheckDirty = false;
          $scope.currentPet = angular.copy($scope.currentPetCopy);
          $scope[$scope.tab.id].$setPristine();
          $scope[$scope.tab.id].$setUntouched();
          $scope.tab.id = $scope.tab.current;
          $scope.tab.current = '';
          $scope.error.status = false;
          window.scrollTo(0, 0);
          $scope.updatePath();
        } else if (
          $scope[$scope.tab.id] != undefined &&
          ($scope[$scope.tab.id].$invalid || $scope[$scope.tab.id].$dirty)
        ) {
          $scope.formcheckDirty = true;
          $scope.tab.current = param;
        } else {
          $scope.tab.id = param;
          $scope.error.status = false;
          window.scrollTo(0, 0);
          $scope.updatePath();
        }
      };

      $scope.updatePath = function () {
        $location.search({ tab: $scope.tab.id });
      };
      var params = $location.search();
      if (params.tab && params.tab != '') {
        $scope.tab = { id: params.tab };
        $scope.tabChanges(params.tab);
      }

      $scope.updatePetDetails = function (param) {
        $scope.error.status = false;
        var postData = angular.copy($scope.updateData);
        postData.pet.petprofile.medical_conditions = [];
        postData.pet.petprofile.family_medical_conditions = [];
        postData.pet.petprofile.id_has_collar = false;
        postData.pet.petprofile.id_has_id_chip = false;
        postData.pet.petprofile.id_has_tag = false;
        postData.pet.species = $scope.currentPet.pet.species;
        angular.element.each(angular.element('#' + param).serializeArray(), function (_, kv) {
          if (kv.name.toLowerCase() == 'medical_conditions') {
            postData.pet.petprofile.medical_conditions.push(kv.value);
          } else if (kv.name.toLowerCase() == 'family_medical_conditions') {
            postData.pet.petprofile.family_medical_conditions.push(kv.value);
          } else if (kv.name.toLowerCase() == 'owner_identifications') {
            if (kv.value.indexOf('id_has_collar') > -1) {
              postData.pet.petprofile.id_has_collar = true;
            }
            if (kv.value.indexOf('id_has_tag') > -1) {
              postData.pet.petprofile.id_has_tag = true;
            }
            if (kv.value.indexOf('id_has_id_chip') > -1) {
              postData.pet.petprofile.id_has_id_chip = true;
            }
          } else if (
            kv.name == 'family_medical_condition_other_info' ||
            kv.name == 'medical_condition_other_info' ||
            kv.name == 'id_other_info'
          ) {
            postData.pet.petprofile[kv.name] = kv.value;
          } else if (kv.name == 'gender') {
            if (JSON.parse(kv.value)) postData.pet.is_male = true;
            else postData.pet.is_male = false;
          } else if (
            kv.name == 'id_has_collar' ||
            kv.name == 'id_has_tag' ||
            kv.name == 'id_has_id_chip'
          ) {
            if (angular.element('.' + kv.name).prop('checked') == true)
              postData.pet.petprofile[kv.name] = true;
          } else if (kv.name == 'sterilized') {
            if (kv.value == '') {
              kv.value = null;
            }
            postData.pet.petprofile[kv.name] = kv.value;
          } else if (postData.hasOwnProperty(kv.name)) {
            postData.pet[kv.name] = $.makeArray(postData[kv.name]);
            postData.pet[kv.name].push(kv.value);
          } else {
            postData.pet[kv.name] = kv.value;
          }
        });
        if (param == 'editpet') {
          if ($scope.lastBreedValue == null) {
            $scope.error.status = true;
            $scope.error.details = 'Please fix the highlighted field(s).';
            $scope.error.highlightedFields.breed = ['Invalid breed'];
            return;
          } else postData.pet.breed = $scope.currentPetBreedId;
        }

        PetsService.updateProPetProfile($scope.currentPetId, $scope.ownerId, postData).then(
          function (result) {
            $scope.submit.success = true;
          },
          function (error) {
            if (error.status == 500) {
              $scope.error.details =
                'There was an error with your request. Please try again in a few minutes.';
            } else if (error.status == 400) {
              $scope.error.details = 'Please fix the highlighted field(s).';
              $scope.error.highlightedFields = error.data.pet;
            } else {
              $scope.error.details = error.statusText;
            }
            $scope.error.status = true;
          },
        );
      };
      $scope.$watch(
        'currentPet.pet.date_of_birth',
        function (newVal, oldVal) {
          if (newVal !== oldVal)
            $scope.petDobInvalid = $scope.currentPet.pet.date_of_birth > $scope.todaysDate;
        },
        true,
      );

      $scope.$on('sheltarChanged', function (event, changedValue) {
        $scope.selectedSheltar = changedValue.data;
        $scope.sheltarData = ProvidersService.getSheltar();
        providerData.petProvider.organization = $scope.sheltarData.id;
        providerData.petProvider.relation_type = 'shelter';
        PetsService.updatePetProShelter($scope.currentPetId, providerData).then(function (
          response,
        ) {
          console.log(response);
        });
      });

      $scope.$on('selectedVeterinarian', function (event, changedValue) {
        $scope.selectedVaterinarian = changedValue.data;
        $scope.vetData = ProvidersService.getVeterinarian();
        providerData.petProvider.organization = $scope.vetData.id;
        providerData.petProvider.relation_type = 'primary';
        PetsService.updatePetProShelter($scope.currentPetId, providerData).then(function (
          response,
        ) {
          console.log(response);
        });
      });

      $scope.$on('$viewContentLoaded', function () {
        PetsService.getProPetProfile($scope.currentPetId, $scope.ownerId).then(function (response) {
          $scope.currentPet.pet = response;
          IdentityService.getUser($scope.ownerId).then(function (response) {
            $scope.setCurrentPetOwner(response);
            ProvidersService.setPetownerZipcode(response.zip);
          });
          $scope.currentPetCopy = angular.copy($scope.currentPet);
          $scope.updateData = angular.copy($scope.currentPet);

          if ($scope.currentPet.pet.providers[0] != undefined)
            $scope.selectedVaterinarian = $scope.currentPet.pet.providers[0].organization.name;
          if ($scope.currentPet.pet.providers[1] != undefined)
            $scope.selectedSheltar = $scope.currentPet.pet.providers[1].organization.name;

          $scope.isMale.value = $scope.currentPet.pet.is_male;
          PetsService.getBreeds().then(function (response) {
            $scope.breedList = response.breeds;
            $rootScope.breedList = response.breeds;
            $scope.lastBreedValue = response.breeds.filter(function (breed) {
              if (breed.id == $scope.currentPet.pet.breed) return true;
            });
            $scope.currentPetBreedId = $scope.lastBreedValue[0].id;
            $scope.currentBreedTitle = $scope.lastBreedValue[0].name;
          });
        });

        IdentityService.getUser($scope.ownerId).then(function (res) {
          $scope.selectedOwner = res.first_name + ' ' + res.last_name;
        });

        $scope.crumbleGenerated = false;
        $scope.generatingCrumble = function () {
          if ($scope.currentPet.pet.name && $scope.crumbleGenerated == false) {
            crumble.update();
            $scope.crumble = crumble;
            if ($scope.crumble.trail[1].label.indexOf('Administrative') !== -1) {
              $scope.crumble.trail[4].label = 'Edit ' + $scope.currentPet.pet.name;
              $scope.crumble.trail[3].label = $scope.currentPet.pet.name;
              $scope.crumble.trail[3].path = $scope.crumble.trail[3].path.replace(
                ':petId',
                $scope.currentPet.pet.id,
              );
            } else {
              $scope.crumble.trail[3].label = 'Edit ' + $scope.currentPet.pet.name;
              $scope.crumble.trail[2].label = $scope.currentPet.pet.name;
              $scope.crumble.trail[2].path = $scope.crumble.trail[2].path.replace(
                ':petId',
                $scope.currentPet.pet.id,
              );
            }
            $rootScope.crumble = $scope.crumble;
            $scope.crumbleGenerated = true;
            return true;
          } else if ($scope.crumbleGenerated == false) {
            return false;
          } else {
            return true;
          }
        };
      });
    },
  );
